/**
 * src/connects/chat-room-members-panel.js
 */

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import context from '../helpers/context'
import combineHOC from '../helpers/combine-hoc'
import { trackPage } from '../helpers/analytics'
import { emitAlertMessage } from '../actions/alert-message'
import { getArray } from '../helpers/store'

export const mapStateToProps = (state, ownProps)=> {
  return {
		chatRoom: getArray('chat_room_id', state.chatRooms.items, ownProps.chatRoom.chat_room_id),
    rightSidePage: state.rightSidePage.name,
    user: state.user.current,
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    leaveChatRoom: (user, props)=> {
      if (props.user.user_id == user.user_id) {
        dispatch(actions.leaveChatRoom(ownProps.chatRoom.chat_room_id, user.user_id))
        if (props.rightSidePage == 'chat_rooms') {
          props.onCloseDialog()
        }
      }
      else {
        dispatch(actions.excludeChatRoom(ownProps.chatRoom.chat_room_id, user.user_id))
      }
      dispatch(emitAlertMessage({ message: props.user.user_id == user.user_id && 'label:退室しました' || 'label:チャットルームから削除', name: user.name }, 'success'))
    },

    joinChatRoom: (user_id)=> dispatch(actions.joinChatRoom(ownProps.chatRoom.chat_room_id, user_id)),
  }
}

export default combineHOC(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
  context({ showUserSelectionDialog: PropTypes.func }),
  ui({
    state: {
      users: undefined,
    }
  }),
  lifecycle,
  trackPage('chatRoom_members'),
)



// WEBPACK FOOTER //
// ./src/connects/chat-room-members-panel.js